import { render, staticRenderFns } from "./ConsequenceApproval.vue?vue&type=template&id=4043d96a"
import script from "./ConsequenceApproval.vue?vue&type=script&lang=js"
export * from "./ConsequenceApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports